const t = "styles-module__tabList___L4lgS", e = "styles-module__tabItems___T-8a4", _ = "styles-module__tabItem___2bM53", s = "styles-module__reverse___3960W", o = "styles-module__active___nPlLB", a = "styles-module__error___fQVpx", l = "styles-module__tabAdd___QLukv", b = "styles-module__tab___qkmxI", m = "styles-module__tabRemove___z4DGG", d = {
  tabList: t,
  tabItems: e,
  tabItem: _,
  reverse: s,
  active: o,
  error: a,
  tabAdd: l,
  tab: b,
  tabRemove: m
};
export {
  o as active,
  d as default,
  a as error,
  s as reverse,
  b as tab,
  l as tabAdd,
  _ as tabItem,
  e as tabItems,
  t as tabList,
  m as tabRemove
};
